export default __webpack_public_path__ + "locales/pt-BR/ChangeUserTypeDialog.json?hash=613b186c75677e518f5a976b8e1df41a";